import React from 'react';
import Tooltip from 'components/controls/Tooltip';
import styled from 'styled-components';

const TooltipInfoIcon: React.FunctionComponent<{ content: JSX.Element | string }> = ({ content }) => {
  return (
    <Image className="pi pi-info-circle">
      <Tooltip position="right" offset={4}>
        {content}
      </Tooltip>
    </Image>
  );
};

const Image = styled.i`
  height: 1rem;
  vertical-align: top;
  margin: 0 0.5rem;
`;

export default TooltipInfoIcon;
